import { DeepChat } from "deep-chat-react";
import "./App.css";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import AIcon from "./images/star2.png";
import UserImg from "./images/user3.png";

export const App = () => {
  const query = new URLSearchParams(window.location.search);
  const isWhite = query.get("theme") !== "dark" || false;
  const isRTL = query.get("rtl") === "true" || false;
  const assistantId = query.get("assistant_id") || "asst_RTpyDTujpSkjYe7rhoVc66ut";
  const lg = query.get("lg") || "en";
  const chatElementRef = useRef(null);
  const [reset, setReset] = useState(false);
  const [threadId, setThreadId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const api_url = process.env.REACT_APP_API_BASE_URL;

  const welcomeMessages = {
    en: "Hi There! I'm Dan, and my role is to answer any questions about developing an AI assistant for your website.",
    he: "היי, מה נשמע? מדברת שרה, תפקידי לענות על כל שאלה לגבי פיתוח עוזר AI לאתר שלך.",
    fr: "Bonjour ! Je suis Dan, et mon rôle est de répondre à toutes vos questions concernant le développement d'un assistant IA pour votre site web.",
    // Add more languages as needed
  };

  const placeholderTexts = {
    en: "Type a message...",
    he: "הקלד הודעה...",
    fr: "Tapez un message...",
    // Add more languages as needed
  };

  const welcomeMsg = welcomeMessages[lg] || welcomeMessages.en;
  const placeholderText = placeholderTexts[lg] || placeholderTexts.en;

  const initialMessages = [
    {
      role: "ai",
      text: welcomeMsg,
    },
  ];

  // Fetch a new thread ID from the API when the component mounts or resets
  useEffect(() => {
    axios
      .get(`${api_url}/chat/create-thread`, {
        params: { assistant_id: assistantId },
      })
      .then((response) => {
        setThreadId(response.data.thread_id);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [reset, api_url, assistantId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (chatElementRef.current && !chatElementRef.current.contains(event.target)) {
        setIsModalOpen(false);
        window.parent.postMessage(
          {
            type: "chatbot-visibility",
            isVisible: false,
          },
          "*"
        );    
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  // Intercept and modify the request details before sending
  const handleRequestInterceptor = (requestDetails) => {
    requestDetails.body = {
      text: requestDetails.body.messages[0].text,
      role: "user",
      thread_id: threadId,
      assistant_id: assistantId,
    };
    return requestDetails;
  };

  const toggleChatVisibility = () => {
    setIsModalOpen(true);
    window.parent.postMessage(
      {
        type: "chatbot-visibility",
        isVisible: true,
      },
      "*"
    );
  };



  // Close chat visibility, reset the chat, and notify the parent window


  useEffect(() => {
    const handleResize = (event) => {
      if (event.data.type === "resize" && chatElementRef.current) {
        const width = event.data.width;
        const height = event.data.height;
        if (width !== 0) {
          chatElementRef.current.style.width = `${width}px`;
          chatElementRef.current.style.height = `${height}px`;
        }
      }
    };
    window.addEventListener("message", handleResize);
    return () => {
      window.removeEventListener("message", handleResize);
    };
  }, []);


  const marginRight = isRTL ? "0px" : "auto";
  const marginLeft = isRTL ? "auto" : "0px";
  const he = "640px";
  const we = "630px";

  //https://daisyui.com/components/dropdown/
  return (
    <>
      {!isModalOpen && (
        <div id="ai-chat-container" style={{position: 'fixed', bottom: '20px', right: '12px', zIndex: 1000}}>
          <button
            id="chat-toggle"
            onClick={toggleChatVisibility}
            style={{
              padding: '10px 20px',
              backgroundColor: '#0f172a',
              color: 'white',
              border: 'none',
              borderRadius: '9999px',
              cursor: 'pointer',
              fontSize: '18px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'transform 0.3s ease',
            }}
            onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.85)'}
            onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            Ask AI
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" style={{width: '24px', height: '24px'}}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z" />
            </svg>
          </button>
        </div>
      )}

      {isModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 2000,
            opacity: 0,
            transition: 'opacity 0.3s ease-in-out',
            animation: 'fadeIn 0.3s forwards',
          }}
        >
          <div 
            className="overflow-hidden"
            style={{
              transform: 'scale(0.95)',
              transition: 'transform 0.3s ease-in-out',
              animation: 'scaleIn 0.3s forwards',
            }}
          >
        <DeepChat
        id="deep-chat"
        stream={true}
        ref={chatElementRef}
        style={{
          height: "640px",
          width: "630px",
          direction: isRTL ? "rtl" : "ltr",
          border: isWhite
            ? "1px solid rgba(230,233,236)"
            : "1px solid rgba(0,0,0,0.7)",
          borderRadius: "15px",
          backgroundColor: isWhite ? "#ffffff" : "#191E23",
          overflow: "hidden", // Add this to ensure content doesn't overflow
        }}
        avatars={{
          ai: {
            src: AIcon,
            styles: {
              position: "left",
              avatar: {
                width: "25px",
                height: "25px",
              },
            },
          },
          user: {
            src: UserImg,
            styles: {
              position: "left",
              avatar: {
                width: "25px",
                height: "25px",
              },
            },
          },
        }}
        initialMessages={initialMessages}
        request={{
          url: api_url + "/chat/start-chat",
          method: "POST",
        }}
        requestInterceptor={handleRequestInterceptor}
        responseInterceptor={(responseDetails) => {
          console.log(responseDetails);
          return responseDetails;
        }}
        textInput={{
          styles: {
            container: {
              borderRadius: "20px",
              border: "unset",
              width: "78%",
              backgroundColor: isWhite
                ? "rgba(255,255,255)"
                : "rgb(20,24,28)",
              boxShadow: isWhite
                ? "3px 3px 3px 2px rgba(230,233,236)"
                : "3px 3px 3px 2px rgba(0,0,0,0.7)",
            },
            text: {
              padding: "10px",
              textAlign: isRTL ? "right" : "left",
              paddingLeft: "15px",
              paddingRight: "34px",
              fontSize: "1.1em",
              color: isWhite ? "#000000" : "#ffffff",
            },
          },
          placeholder: {
            text: placeholderText,
            style: {
              color: isWhite ? "#606060" : "#b0b0b0",
            },
          },
        }}
        messageStyles={{
          default: {
            shared: {
              bubble: {
                textAlign: isRTL ? "right" : "left",
                direction: isRTL ? "rtl" : "ltr",
                backgroundColor: "unset",
                marginTop: "10px",
                marginBottom: "10px",
                maxWidth: "100%",
                marginRight: marginRight,
                marginLeft: marginLeft,
                fontSize: "1.1em",
                color: isWhite ? "#000000" : "#ffffff",
              },
              outerContainer: {
                direction: isRTL ? "rtl" : "ltr",
              },
            },
            user: {
              bubble: {
                color: isWhite ? "black" : "white",
              },
              outerContainer: {
                borderBottom: isWhite
                  ? "1px solid rgba(230,233,236)"
                  : "1px solid rgba(0,0,0,0.7)",
              },
            },
            ai: {
              outerContainer: {
                backgroundColor: isWhite
                  ? "rgba(255,255,255)"
                  : "rgb(25,30,35)",
                borderBottom: isWhite
                  ? "1px solid rgba(230,233,236)"
                  : "1px solid rgba(0,0,0,0.7)",
              },
            },
          },
          loading: {
            bubble: { padding: "0.6em 1.78em 0.6em 1.3em" },
          },
        }}
        submitButtonStyles={{
          position: isRTL ? "inside-left" : "inside-right",
          submit: {
            container: {
              default: {
                bottom: "0.8em",
                borderRadius: "25px",
                padding: "6px 5px 4px",
                backgroundColor: "unset",
              },
              hover: {
                backgroundColor: isWhite ? "#b0deff4f" : "#333333",
              },
              click: {
                backgroundColor: isWhite ? "#b0deffb5" : "#4c4c4c",
              },
            },
            svg: {
              content:
                '<?xml version="1.0" encoding="utf-8"?> <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m21.426 11.095-17-8A.999.999 0 0 0 3.03 4.242L4.969 12 3.03 19.758a.998.998 0 0 0 1.396 1.147l17-8a1 1 0 0 0 0-1.81zM5.481 18.197l.839-3.357L12 12 6.32 9.16l-.839-3.357L18.651 12l-13.17 6.197z"/></svg>',
              styles: {
                default: {
                  width: "1.5em",
                  filter: isWhite
                    ? "brightness(0) saturate(100%) invert(10%) sepia(86%) saturate(6044%) hue-rotate(205deg) brightness(100%) contrast(100%)"
                    : "brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(170deg) brightness(0%) contrast(0%)",
                },
              },
            },
          },
          loading: {
            text: {
              styles: {},
            },
            svg: {
              styles: {
                default: {
                  filter: isWhite
                    ? "brightness(0) saturate(100%) invert(72%) sepia(0%) saturate(3044%) hue-rotate(322deg) brightness(100%) contrast(96%)"
                    : "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(1000%) hue-rotate(90deg) brightness(0%) contrast(0%)",
                },
              },
            },
          },
          stop: {
            container: {
              hover: {
                backgroundColor: isWhite ? "#ededed94" : "#555555",
              },
            },
            svg: {
              styles: {
                default: {
                  filter: isWhite
                    ? "brightness(0) saturate(100%) invert(72%) sepia(0%) saturate(3044%) hue-rotate(322deg) brightness(100%) contrast(96%)"
                    : "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(1000%) hue-rotate(90deg) brightness(0%) contrast(0%)",
                },
              },
            },
          },
        }}
        attachmentContainerStyle={{
          backgroundColor: "unset",
          top: "-2.6em",
          height: "4em",
        }}
      />
        </div>
      </div>
    )}
    <style>
      {`
        @keyframes fadeIn {
          to { opacity: 1; }
        }
        @keyframes scaleIn {
          to { transform: scale(1); }
        }
      `}
    </style>
  </>
);
};

export default App;